import Plyr from 'plyr';

const video = () => {
  // eslint-disable-next-line no-unused-vars
  const player = new Plyr('.u-plyr', {
    controls: [
      'play-large',
      'play',
      'progress',
      'current-time',
      'mute',
      'volume',
    ],
    autoplay: true,
    muted: true,
    loop: {
      active: true,
    },
    volume: 0,
    hideControls: true,
    iconPrefix: 'cplyr',
  });
};

export default video;



// WEBPACK FOOTER //
// ./public/wp-content/themes/druckhaus/src/scripts/modules/video.js